export const KTV_DARK_BLUE = "#07375F";
export const KTV_BACKGROUND_GREY = "#242424"; // 14%
export const KTV_NAV_GREY = "#333"; // 20%
export const KTV_BORDER_GREY = "#3d3d3d"; // 24%
export const KTV_LIGHT_GREY = "#555"; // 33%
export const KTV_GREY = "#777"; // 47%
export const KTV_LINE_GREY = "#a6a6a6"; // 65%
export const KTV_TEXT_GREY = "#C8C8C8"; // 78%
export const KTV_PROMPT_GREY = "#d5d5d5"; // 84%
